import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLeft = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M15.0003 20.25C14.9018 20.2502 14.8042 20.2308 14.7132 20.1931C14.6222 20.1554 14.5395 20.1001 14.4699 20.0304L6.96993 12.5304C6.90028 12.4607 6.84503 12.378 6.80734 12.287C6.76964 12.196 6.75024 12.0985 6.75024 12C6.75024 11.9015 6.76964 11.804 6.80734 11.713C6.84503 11.622 6.90028 11.5393 6.96993 11.4697L14.4699 3.96968C14.6106 3.82902 14.8014 3.75 15.0003 3.75C15.1992 3.75 15.39 3.82902 15.5306 3.96968C15.6713 4.11033 15.7503 4.3011 15.7503 4.50002C15.7503 4.69894 15.6713 4.88971 15.5306 5.03036L8.56096 12L15.5306 18.9697C15.6355 19.0746 15.707 19.2082 15.7359 19.3537C15.7648 19.4992 15.75 19.65 15.6932 19.787C15.6364 19.9241 15.5403 20.0412 15.417 20.1236C15.2936 20.206 15.1486 20.25 15.0003 20.25Z",
		fill: "#1C1C1E"
	})]
});
const ForwardRef = forwardRef(SvgLeft);
export default ForwardRef;
